import axios from "axios";
import { useContext, useEffect, useState } from "react";
import "react-circular-progressbar/dist/styles.css";

import { supabase } from "../services/auth";

import AuthBasic, { AuthDialog } from "../components/Auth";
import PremiumDialog from "../components/PremiumDialog";
import UserContext from "../components/UserContext";
import Header from "../components/Header";
import Footer from "../components/Footer";
import CreateResult from "../components/create/CreateResult";
import CreatePrompt from "../components/create/CreatePrompt";
import { getUser } from "../services/supabase";
import BulkCreateDialog from "../components/BulkCreateDialog";
import { useRouter } from "next/router";

const prompts = [
    "A cute bear",
    "An astronaut walking on Mars",
    "Low poly bird",
    "Illustration of mountain landscape",
];

async function convertToPng(arrayBuffer) {
    // Create a blob from the ArrayBuffer
    const blob = new Blob([arrayBuffer]);

    // console.log("blob", blob);
    // console.log(arrayBuffer);

    // Create a new Image object
    const img = new Image();

    // Create a canvas element
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");

    // Convert blob to URL
    const url = URL.createObjectURL(blob);

    // Return a promise that resolves with the PNG data URL
    return new Promise((resolve, reject) => {
        img.onload = () => {
            // Set canvas dimensions to fixed 1024x1024
            canvas.width = 1024;
            canvas.height = 1024;

            // Calculate dimensions while preserving aspect ratio
            const aspectRatio = img.width / img.height;
            let newWidth, newHeight;
            let offsetX = 0, offsetY = 0;

            if (aspectRatio > 1) {
                // Landscape
                newWidth = canvas.width;
                newHeight = canvas.width / aspectRatio;
                offsetY = (canvas.height - newHeight) / 2;
            } else {
                // Portrait
                newHeight = canvas.height;
                newWidth = canvas.height * aspectRatio;
                offsetX = (canvas.width - newWidth) / 2;
            }

            // Clear canvas and draw centered image
            ctx.fillStyle = 'white';  // Optional: fill background
            ctx.fillRect(0, 0, canvas.width, canvas.height);
            ctx.drawImage(img, offsetX, offsetY, newWidth, newHeight);

            // Convert to PNG data URL
            const pngUrl = canvas.toDataURL("image/png");

            // Clean up blob URL
            URL.revokeObjectURL(url);

            resolve(pngUrl);
        };

        img.onerror = () => {
            URL.revokeObjectURL(url);
            reject(new Error("Failed to load image"));
        };

        // Set image source to start loading
        img.src = url;
    });
}

function PremiumDialogActual(props) {
    // if (props.user?.id && props.user.id.slice(-1) > '8') {
    //     return <PremiumDialog2 {...props} />;
    // }
    return <PremiumDialog {...props} />;
}

export function CreateLayout(props) {
    const user = props.user;
    const router = useRouter();

    const [selectedMode, setSelectedMode] = useState(
        props.initialMode ? props.initialMode : props.initialCollection ? "collection" : "simple"
    );
    const [selectedAuxMode, setSelectedAuxMode] = useState(
        props.initialCollection
    );
    const [svgUrl, setSvgUrl] = useState(props.initialUrl);
    const [identifier, setIdentifier] = useState();
    const [isFallback, setIsFallback] = useState(false);
    const [loadingTime, setLoadingTime] = useState(0);
    const [prompt, setPrompt] = useState();
    const [isBoost, setIsBoost] = useState(false);
    const [sketchData, setSketchData] = useState(null);
    const [uploadData, setUploadData] = useState(null);
    const [isCreating, setIsCreating] = useState(false);
    const [status, setStatus] = useState(null);
    const [error, setError] = useState("");
    const [creditsRemaining, setCreditsRemaining] = useState(null);
    const [showPurchase, setShowPurchase] = useState(false);
    const [showLogin, setShowLogin] = useState(false);
    const [showBulk, setShowBulk] = useState(false);

    useEffect(() => {
        if (props.uploadData) {
            setUploadData(props.uploadData);
        }
    }, [props.uploadData]);

    const poll = async (identifier, pollingTime) => {
        console.log(identifier, pollingTime);
        const result = await axios.post(`/api/image/status`, {
            identifier,
        });
        if (result?.data?.status) {
            console.log(result?.data?.status);
            setStatus(result.data.status);
            setIsFallback(result.data.fallback || result.data.genFallback);
            if (result.data.status === "error") {
                setError(
                    result.data.nsfw
                        ? "NSFW content detected. Please adjust your prompt and try again."
                        : "Something went wrong. Try again..."
                );
                setIsCreating(false);
                window.umami?.track("Create Error", {
                    time: pollingTime,
                    error: result.data,
                });
                return;
            }
        } else if (pollingTime > 120) {
            setError("Something went wrong. Try again...");
            setIsCreating(false);
            window.umami?.track("Create Error", {
                time: pollingTime,
            });
            return;
        } else {
            setTimeout(() => {
                poll(identifier, pollingTime);
            }, 2000);
            return;
        }
        setLoadingTime(pollingTime);
        setIdentifier(identifier);
        if (result?.data?.svg) {
            setIsCreating(false);
            setSvgUrl(
                result?.data?.fallback
                    ? `https://my.vectorart.ai/storage/v1/object/public/vectorart-upload/${result.data.svg}`
                    : `https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/${result.data.svg}/sm`
            );
            window.umami?.track("Create Done", {
                svg: result.data.svg,
                prompt,
                time: pollingTime,
            });
            props.onSelectItem?.(result.data);
        } else {
            setTimeout(() => {
                poll(
                    identifier,
                    ["active", "queued_1"].includes(result?.data?.status)
                        ? (pollingTime || 0) + 1
                        : pollingTime || 0
                );
            }, 2000);
        }
    };
    const go = async () => {
        if ((!prompt && !uploadData) || isCreating) {
            return;
        }
        setIsCreating(true);
        setError(null);
        setIdentifier(null);
        setLoadingTime(0);
        setSvgUrl(null);

        let inError = false;
        let pngData = null;
        let dataStrength = undefined;

        if (uploadData) {
            //convert arbitrary file selected to png image
            const png = await convertToPng(uploadData).catch((err) => {
                window.umami?.track("Create Upload PNG Error", {
                    prompt,
                    selectedMode,
                    err,
                });
            });
            pngData = png;
            dataStrength = prompt ? 0.3 : 0.5;
        }

        const identifier =
            Math.random().toString(36).substring(2, 15) +
            Math.random().toString(36).substring(2, 15);
        axios
            .post(`/api/image/create`, {
                prompt: prompt || "vectorize this image",
                identifier,
                boost: isBoost,
                mode: selectedMode?.toLowerCase()?.replace(/ /g, "-"),
                auxMode: selectedAuxMode,
                sketchData: pngData || sketchData,
                strength: dataStrength
            })
            .then((result) => {
                setCreditsRemaining(result?.data?.credits);
            })
            .catch((err) => {
                inError = true;
                setIsCreating(false);
                if (err?.response?.status === 401) {
                    setShowPurchase(true);
                    window.umami?.track("Create Show Purchase", {
                        prompt,
                        selectedMode,
                    });
                } else if (err?.response?.status === 400) {
                    window.umami?.track("Create No Auth", {
                        prompt,
                        selectedMode,
                    });
                    setShowLogin(true);
                } else if (err?.response?.status === 422) {
                    window.umami?.track("Create Error", {
                        prompt,
                        selectedMode,
                        err,
                    });
                    setError(
                        "Too many simultaneous requests. Wait for some to finish and try again..."
                    );
                } else if (err?.response?.status === 413) {
                    window.umami?.track("Create Error File Too Large", {
                        prompt,
                        selectedMode,
                        err,
                    });
                    setError("File too large. Try a different image...");
                } else {
                    window.umami?.track("Create Error", {
                        prompt,
                        selectedMode,
                        err,
                    });
                    setError("Something went wrong. Try again...");
                }
            });

        // console.log(result);
        setTimeout(() => {
            if (!inError) {
                poll(identifier);
            }
        }, 5000);
        window.umami?.track("Create Image", {
            prompt,
            selectedMode,
            selectedAuxMode,
        });
    };

    useEffect(() => {
        if (props.skipRandomPrompt) {
            return;
        }
        setPrompt(
            props.initialPrompt ||
                prompts[
                    Math.max(
                        0,
                        Math.min(
                            prompts.length - 1,
                            Math.round(Math.random() * prompts.length)
                        )
                    )
                ]
        );
    }, []);

    // {/* <div className="w-full bg-red-700 text-center text-white text-sm p-4">VectorArt is experiencing increased errors due to an upstream service outage</div> */}
    return (
        <>
            <CreateResult
                svgUrl={svgUrl}
                isCreating={isCreating}
                error={error}
                status={status}
                identifier={identifier}
                loadingTime={loadingTime}
                isFallback={isFallback}
                initialComponent={props.initialComponent}
                isMinimal={props.isExternal}
                uploadData={uploadData}
                dropzone={props.dropzone}
                previewView={props.previewView}
                onSelectItem={props.onSelectItem}
                showDownloadPng={props.showDownloadPng}
                showPrint={props.showPrint}
            />
            <CreatePrompt
                initialMode={selectedMode}
                initialAuxMode={selectedAuxMode}
                isCreating={isCreating}
                setPrompt={setPrompt}
                prompt={prompt}
                setSelectedMode={(mode, auxMode) => {
                    setSelectedMode(mode);
                    setSelectedAuxMode(auxMode);
                    window.umami?.track("Create Prompt - Mode", {
                        mode: mode,
                    });
                }}
                onCreate={() => go()}
                onBulkCreate={() => {
                    setShowBulk(true);
                    window.umami?.track("Create Prompt - Bulk create", {});
                }}
                isBoost={isBoost}
                setIsBoost={setIsBoost}
                setSketchBinaryData={setSketchData}
                setUploadBinaryData={setUploadData}
                showPremium={() => setShowPurchase(true)}
                creditsRemaining={creditsRemaining}
                hideMisc={!!selectedAuxMode || props.isExternal}
                isSimple={props.isSimple}
                placeholder={props.placeholder}
            />
            {showLogin ? (
                <AuthDialog
                    open={showLogin}
                    setOpen={setShowLogin}
                    supabase={supabase}
                    url={router.asPath}
                    title="Sign up to continue creating for free"
                />
            ) : null}
            {showPurchase ? (
                <PremiumDialogActual
                    user={user || props.user}
                    onClose={() => setShowPurchase(false)}
                />
            ) : (
                showBulk && (
                    <BulkCreateDialog
                        user={user || props.user}
                        initialPrompt={prompt}
                        initialMode={selectedMode}
                        initialAuxMode={selectedAuxMode}
                        setShowPurchase={setShowPurchase}
                        onClose={({ isDone, data }) => {
                            setShowBulk(false);
                            console.log("closed", isDone, data);
                            if (isDone && data.svg) {
                                setSvgUrl(
                                    data?.fallback
                                        ? `https://my.vectorart.ai/storage/v1/object/public/vectorart-upload/${data.svg}`
                                        : `https://imagedelivery.net/xE-VtsYZUS2Y8MtLMcbXAg/${data.svg}/sm`
                                );
                            }
                        }}
                    />
                )
            )}
        </>
    );
}

export default function CreatePage(props) {
    const { user } = useContext(UserContext);
    if (!user && !props.user) {
        return (
            <div className="w-full h-screen flex flex-col dark:bg-gray-950">
                <div className="relative border-b border-gray-100 dark:border-gray-900">
                    <div className="container mx-auto">
                        <Header
                            className="secondary"
                            {...props}
                            supabase={supabase}
                            user={user}
                            showCreate={false}
                            title="Create"
                            description="Create vector graphics with AI"
                        />
                    </div>
                </div>
                <div className="container mx-auto">
                    <div className="flex space-x-4 mt-6 mx-4 sm:mx-32 md:mx-48 lg:mx-64 xl:mx-96 items-center justify-center  pt-16">
                        <AuthBasic
                            supabase={supabase}
                            redirectTo="/create"
                            onSignedIn={(user) => {
                                console.log("signed in");
                                window.location.reload();
                            }}
                        />
                    </div>
                </div>
                <div className="mt-32">
                    <Footer />
                </div>
            </div>
        );
    }
    return (
        <div className="w-full h-screen flex flex-col bg-gray-100 dark:bg-gray-950">
            <div className="relative border-b border-gray-200 dark:border-gray-800 bg-white  z-10 dark:bg-gray-900">
                <div className="container mx-auto">
                    <Header
                        className="secondary "
                        {...props}
                        supabase={supabase}
                        user={user}
                        showCreate={false}
                        description="Create vector graphics with AI"
                    />
                </div>
            </div>
            <CreateLayout user={user} {...props} />
        </div>
    );
}

export async function getServerSideProps(context) {
    const user = await getUser(context.req);
    return {
        props: {
            initialPrompt: context.query?.prompt || null,
            initialCollection: context.query?.collection || null,
            user: user
                ? {
                      id: user.id,
                      email: user.email,
                  }
                : null,
        },
    };
}
